import { Link } from '@tanstack/react-router';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { LIST_ROW_LINK } from '@/shared/components/listRow';

/**
 * A workflow's name as a link to it, with Draft when it is one: the ledger's detail
 * and the step map draw the same link (specs 230, 233), in the list-row name style
 * Spend's workflow names use too (spec 234).
 */
export function WorkflowNameLink({
  workspaceId,
  workflowKey,
  workflowName,
  draft,
}: {
  workspaceId: string;
  workflowKey: string;
  workflowName: string;
  draft: boolean;
}) {
  return (
    <span className="flex min-w-0 flex-wrap items-center gap-2">
      <Link
        to="/workspaces/$workspaceId/workflows/$workflowKey"
        params={{ workspaceId, workflowKey }}
        className={cn(
          LIST_ROW_LINK,
          'touch-target inline-flex items-center text-sm',
        )}
      >
        {workflowName}
      </Link>
      {draft && <Badge variant="secondary">Draft</Badge>}
    </span>
  );
}
